import { render, staticRenderFns } from "./VerticalScroll.vue?vue&type=template&id=08277a76&"
import script from "./VerticalScroll.vue?vue&type=script&lang=js&"
export * from "./VerticalScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports